import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSbp: CultureInfo = {
  name: 'sbp',
  displayName: 'Ishisangu',
  iso3LanguageCode: 'sbp',
  iso2LanguageCode: 'sbp',
  ietfLanguageTag: 'sbp',
  parent: null
};
